import {
	initOrtInput,
	callPLZService
} from "../../plzService";

var ortDropdown1	 = $('[id="adr.ort"]');
var plzInputFieldId1 = $('[id="adr.plz"]');
var infoFieldId1 	 = $('[id="plzOK"]');
var ladekringelId1   = $('[id="ladekringel"]');

$(document).ready( function() {
	var $datgeb = $("#datgeb");
	var $datgeb1Row = $(".datgeb1Row");

	$datgeb.on("change", function() {
		if($datgeb.val().substring(2,4) > 12 || $datgeb.val().substring(0,2) > 31) {
			$datgeb1Row.show();
		} else {
			$datgeb1Row.hide();
		}
	});
	$datgeb.trigger("change");
	callPLZService(ortDropdown1, plzInputFieldId1, infoFieldId1, ladekringelId1, null, null);
});